// Validation Engine
// Author: Luis Booth - November 2018

import validator from 'js/modules/validator';

const validationEngine = {};

// This function will dynamically validate inputs. You will need to define the
// input name and the validation rule you want to apply in 'validationRules' object
const _runSimpleValidator = (validationRules, value, name, breakAtError = true) => {

  const validationsObject = {[name]: {}};
  let allValid = true;

  for(const ruleName of validationRules[name]) {
    const genericValidation = validator[ruleName];
    const isValid = genericValidation.validate(value);
    const obj = {
      inputName: name,
      validationRule: ruleName,
      isValid,
      message: genericValidation.message || '',
      errorJSX: !isValid ? genericValidation.hint(value) : '',
    };

    validationsObject[name][ruleName] = obj;
    allValid = allValid && isValid;

    if(!isValid && breakAtError) {
      break;
    }
  }

  return { validationsObject, allValid };
};

// Work in progress
const _runComplexValidator = () => {
  return {
    isValid: 'genericValidation.validate(value)',
    errorJSX: 'genericValidation.hint(value)'
  };
};

validationEngine.runValidations = (validationRules, value, name) => {

  const isArray = Array.isArray(validationRules[name]);

  return isArray ? _runSimpleValidator(validationRules, value, name) : _runComplexValidator(validationRules, value, name);
};

// Export Validation Engine ===========================
export default validationEngine;



// WEBPACK FOOTER //
// ./js/modules/validationEngine.js